import { v4 } from 'uuid';

import {
  ADD_CARD_SORT_CATEGORY_ITEM,
  ADD_EMPTY_CATEGORY,
  MOVE_CARD_SORT_CATEGORY,
  MOVE_CARD_SORT_ITEM,
  MOVE_TEST_SESSION_CARD_SORT_ITEM,
  REMOVE_CARD_SORT_CATEGORY_ITEM,
  REMOVE_CARD_SORT_CATEGORY,
  SET_CARD_SORT_CATEGORIES,
  SET_CARD_SORT_ITEMS,
  SET_CARD_SORT_SETTINGS,
  SET_TEST_SESSION_ID,
  UPDATE_CARD_SORT_CATEGORY,
} from './reducer';

export const setCardSortItems = (items) => (dispatch) => {
  dispatch({
    type: SET_CARD_SORT_ITEMS,
    payload: items,
  });
};

export const setCardSortCategories = (categories) => (dispatch) => {
  dispatch({
    type: SET_CARD_SORT_CATEGORIES,
    payload: categories,
  });
};

export const setTestSessionId = (testSessionId) => (dispatch) => {
  dispatch({
    type: SET_TEST_SESSION_ID,
    payload: testSessionId,
  });
};

export const setCardSortSettings = (project) => (dispatch) => {
  const payload = {
    sortType: project.sortType,
    randomCategory: project.randomCategory,
    sortRandom: project.sortRandom,
    tooltipDescription: project.tooltipDescription,
    uploadImage: project.uploadImage,
    hideName: project.hideName,
  };

  dispatch({
    type: SET_CARD_SORT_SETTINGS,
    payload,
  });
};

export const moveCardSortItem = (id, newIndex) => (dispatch) => {
  dispatch({
    type: MOVE_CARD_SORT_ITEM,
    payload: {
      id,
      newIndex,
    },
  });
};

export const moveCardSortCategory = (id, newIndex) => (dispatch) => {
  dispatch({
    type: MOVE_CARD_SORT_CATEGORY,
    payload: {
      id,
      newIndex,
    },
  });
};

export const moveTestSessionCardSortItem = (id, newIndex, categoryId) => (dispatch) => {
  dispatch({
    type: MOVE_TEST_SESSION_CARD_SORT_ITEM,
    payload: {
      id,
      newIndex,
      categoryId,
    },
  });
};

export const addCardSortCategoryItem = (item, categoryId, index) => (dispatch) => {
  dispatch({
    type: ADD_CARD_SORT_CATEGORY_ITEM,
    payload: {
      item,
      categoryId,
      index,
    },
  });
};

export const addEmptyCategory = (projectId, item = null) => (dispatch) => {
  const id = v4();

  dispatch({
    type: ADD_EMPTY_CATEGORY,
    payload: {
      projectId,
      id,
      item,
    },
  });

  return id;
};

export const addCategoryWithItem = (item, projectId) => (dispatch) => {
  const categoryId = addEmptyCategory(projectId, item)(dispatch);
  addCardSortCategoryItem(item, categoryId)(dispatch);
};

export const removeCardSortCategory = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_CARD_SORT_CATEGORY,
    payload: {
      id,
    },
  });
};

export const removeCardSortCategoryItem = (item, categoryTargetId) => (dispatch) => {
  dispatch({
    type: REMOVE_CARD_SORT_CATEGORY_ITEM,
    payload: {
      item,
      categoryTargetId,
    },
  });
};

export const updateCardSortCategory = (category) => (dispatch) => {
  dispatch({
    type: UPDATE_CARD_SORT_CATEGORY,
    payload: {
      category,
    },
  });
};
